import React, { useState } from 'react';
import api from '../api/axiosConfig';
import { showSuccessToast, showErrorAlert } from '../utils/alert';
import Modal from './Modal'; // Pastikan path ini benar

const ChangePasswordModal = ({ show, onClose }) => {
  const [step, setStep] = useState(1); // 1: Minta OTP, 2: Input OTP & Password Baru
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRequestOtp = async () => {
    setLoading(true);
    try {
      const { data } = await api.post('/api/users/profile/request-password-otp');
      showSuccessToast(data.message);
      setStep(2); // Pindah ke langkah input OTP
    } catch (error) {
      showErrorAlert(error.response?.data?.message || "Gagal mengirim OTP.");
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/api/users/profile/change-password', { otp, password });
      showSuccessToast(data.message);
      onClose(); // Tutup modal setelah berhasil
      setStep(1); // Reset step untuk penggunaan selanjutnya
      setOtp('');
      setPassword('');
    } catch (error) {
      showErrorAlert(error.response?.data?.message || "Gagal memperbarui password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onClose={onClose} title="Ganti Password">
      {step === 1 && (
        <div>
          <p>Kami akan mengirimkan kode OTP ke email Anda untuk verifikasi.</p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
            <button onClick={onClose} className="btn-secondary" style={{ marginRight: '10px' }}>Batal</button>
            <button onClick={handleRequestOtp} className="btn-primary" disabled={loading}>
              {loading ? 'Mengirim...' : 'Kirim OTP'}
            </button>
          </div>
        </div>
      )}

      {step === 2 && (
        <form onSubmit={handleChangePassword}>
          <p>Masukkan kode OTP yang dikirim ke email Anda dan password baru.</p>
          <div className="form-group">
            <label>Kode OTP</label>
            <input type="text" value={otp} onChange={(e) => setOtp(e.target.value)} maxLength="6" required />
          </div>
          <div className="form-group">
            <label>Password Baru</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
            <button type="button" onClick={() => setStep(1)} className="btn-secondary" style={{ marginRight: '10px' }}>Kembali</button>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Menyimpan...' : 'Simpan Password Baru'}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default ChangePasswordModal;